module.exports = __webpack_public_path__ + "img/history-main-photo.41d36339.jpg";